module.exports = __webpack_public_path__ + "img/thumbnail_DamaGazelle_m_normal.ae61cfd1.png";